import React from 'react';
import { RouteObject } from 'react-router-dom';
import { UnauthorizedErrorPage, UnexpectedErrorPage } from './views';

export const routes: RouteObject[] = [
  { path: '/error/401', element: <UnauthorizedErrorPage/> },
  { path: '/error/500', element: <UnexpectedErrorPage /> },
];

export default routes;